import React from 'react';
// import Button from '../elements/button';
// import heroImage from '../../assets/images/dr-aina-lab.jpeg';
// import heroBackground from '../../assets/images/hero-bg.png';
import '../../assets/css/sections/hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        // <section className="hero">
        //     <div className="hero-left" style={{ backgroundImage: `url(${heroBackground})` }}>
        //         <div className="hero-overlay">
        //             <div className="hero-content">
        //                 <h1 className="hero-title">
        //                     Revolutionizing Aquaculture Health Management
        //                 </h1>
        //                 <p className="hero-description">
        //                     Advanced AI-powered solutions for monitoring and maintaining 
        //                     optimal health conditions in your aquaculture facility
        //                 </p>
        //                 <Button 
        //                     text="Get Started"
        //                     variant="secondary"
        //                     icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
        //                     onClick={() => window.location.href = '/register'}
        //                 />
        //             </div>
        //         </div>
        //     </div>
        //     <div className="hero-right">
        //         <img src={heroImage} alt="Aquaculture Management" className="hero-image" />
        //     </div>
        // </section>
        <section className="hero-section">
        {/* Video Background */}
        <div className="hero-video-container">
            <video 
            className="hero-video" 
            autoPlay 
            muted 
            loop 
            playsInline
            // poster="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1920&q=80"
            poster="/hero_vid2.mp4"
            >
            {/* <source src="https://videos.pexels.com/video-files/3129671/3129671-hd_1920_1080_30fps.mp4" type="video/mp4" /> */}
            <source src="/hero_vid2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
            </video>
            <div className="hero-video-overlay"></div>
        </div>
        
        <div className="landing-container">
            <div className="hero-content animate-fade-in">
            <h1>Empowering Africa&apos;s <span style={{ color: 'var(--secondary-dark)' }}>Fish Farming</span> Through Technology</h1>
            <p className="subtitle">
                Learn about fish farming, report fish health, get expert veterinary advice, 
                and optimize your aquaculture operations—all in one platform.
            </p>
            <div className="hero-buttons">
                <Link to="/register" className="landing-btn landing-btn-accent landing-btn-lg" style={{backgroundColor:'var(--secondary-teal)'}}>
                Get Started
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
                </Link>
                <Link to="/chat" className="landing-btn landing-btn-secondary landing-btn-lg">
                Ask Beere
                </Link>
            </div>
            {/* <div className="hero-stats">
                <div className="hero-stat">
                <div className="number">500+</div>
                <div className="label">Active Farms</div>
                </div>
                <div className="hero-stat">
                <div className="number">98%</div>
                <div className="label">Disease Prevention</div>
                </div>
                <div className="hero-stat">
                <div className="number">24/7</div>
                <div className="label">Expert Support</div>
                </div>
            </div> */}
            </div>
        </div>
        </section>
    );
};

export default Hero;